<template>
  <!-- 原因  -->
  <div>
    <van-popup
      v-model="showReason"
      :close-on-popstate="true"
      position="bottom"
    >
      <van-picker
        show-toolbar
        title="选择取消原因"
        :columns="reasonList"
        @cancel="toggle"
        @confirm="confirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Picker,Popup } from 'vant'


export default {
  name:'CancelRason',
  components: {
    [Picker.name]:Picker,
    [Popup.name]:Popup,
  },
  data(){
    return{
      showReason:false,
      reasonList : [{
        value: '101',
        text: '选择了其它交通方式'
      },
      {
        value: '102',
        text: '行程改变'
      },
      {
        value: '103',
        text: '车辆太远'
      },
      {
        value: '104',
        text: '与司机达成一致'
      },
      {
        value: '105',
        text: '航班延误或取消'
      },
      {
        value: '106',
        text: '订错了重新下单'
      },
      {
        value: '201',
        text: '司机爽约'
      },
      {
        value: '202',
        text: '司机要求我支付现金'
      },
      {
        value: '203',
        text: '司机电话联系我取消订单'
      },
      {
        value: '204',
        text: '司机说车坏了'
      },
      {
        value: '205',
        text: '司机订单冲突'
      },
      {
        value: '301',
        text: '系统问题'
      },{
        value: '其他原因',
        text: '其他原因'
      }]
    }
  },
  methods: {
    confirm(info){
      this.$emit('selected',info)
      this.toggle()
    },
    toggle(){
      this.showReason=!this.showReason
    },
  },
}
</script>

<style lang="less" scoped>

</style>
